import { InterconsultaUpdate } from "./InterconsultaUpdate";
import { InterconsultaDelete } from "./InterconsultaDelete";
import { NotificacionCreate } from "./NotificacionCreate";
import {
  Link,
  useNavigate,
  useParams,
  useLoaderData,
} from "react-router-dom";
import { useState, useEffect } from "react";
import Select from "react-select";

import { FormatDate } from "../components/documentacion/FormatDate";

import * as APIESPECIALISTAS from "../services/especialistas";
import * as API from "../services/interconsulta";
import * as APIPACIENTES from "../services/pacientes";


export async function loader({ params }) {
  const token = sessionStorage.getItem("token");

  // Si no hay token, simplemente NO llamamos a la API y retornamos null
  if (!token) {
    return null;
  }
  const pacienteData = await APIPACIENTES.getPacienteByID(params.pacienteId);

  // Obtén los datos de interconsulta utilizando el tratamientoId
  const interconsultaData = await API.getInterconsultaByID(params.interconsultaId);

  // Retorna un objeto con los datos necesarios
  return {
    pacienteData: pacienteData,
    interconsultaData: interconsultaData,
  };
}


export function InterconsultaItem(props) {
  const { interconsultaData: interconsulta } = useLoaderData();
  const { pacienteData: paciente } = useLoaderData();
  console.log(interconsulta);

  const navigate = useNavigate();

  // Set default valor for today date
  const todayDate = new Date()
    .toISOString()
    .replace(/T.*/, "")
    .split("-")
    .join("-");

  

  const [interResp, setInterResp] = useState(interconsulta.meta?.interResp);
  const [interRespId, setInterRespId] = useState(interconsulta.author);
  const [metaFecha, setMetafecha] = useState(interconsulta.meta?.metaFecha);
  const [interAsu, setInterAsu] = useState(interconsulta.meta?.interAsu);
  const [interDest, setInterDest] = useState(interconsulta.meta?.interDest);
  const [interDestAllow, setInterDestAllow] = useState(interconsulta.meta?.interDestAllow);
  const [interObs, setInterObs] = useState(interconsulta.meta?.interObs);
  const [interHiloPrev, setInterHiloPrev] = useState(interconsulta.meta?.interHilo);

  const [loading, setLoading] = useState(false);
  const [isCreatingButton, setIsCreatingButton] = useState(false);
  const [isDeletingButton, setIsDeletingButton] = useState(false);

  const [interDestAll, setInterDestAll] = useState(""); // Todos los posibles receptores
  const [interDestOptions, setInterDestOptions] = useState(""); // Todos los posibles receptores - user actual
  const [interDestNot, setInterDestNot] = useState(""); // Los usuarios que recibirán notificación
  const [interDestCurrent, setInterDestCurrent] = useState(interconsulta.meta?.interDest); // Los usuarios que forman parte de la interconsulta actualmente

  const [showGrid, setShowGrid] = useState(false); // Estado para controlar la visibilidad del bloque de respuesta
  const [showModal, setShowModal] = useState(false);

  const [interHiloAutorId, setInterHiloAutorId] = useState(props.especialistaId);
  const [interHiloAutor, setInterHiloAutor] = useState(props.especialistaFullName);
  const [interHiloFecha, setInterHiloFecha] = useState(todayDate);
  // const [interHiloDestinatarios, setInterHiloDestinatarios] = useState();
  const [interHiloMensaje, setInterHiloMensaje] = useState("");

  const [interNoti, setInterNoti] = useState("");
  const [pacienteName, setPacienteName] = useState(paciente.name);

  let { tratamientoId } = useParams();
  let { pacienteId } = useParams();
  let interconsultaId = interconsulta.id;

  const [mensajesEditados, setMensajesEditados] = useState(interconsulta.meta?.interHilo);
  const [mensajeEditando, setMensajeEditando] = useState(null);

  // Manejar cambios en el mensaje. Edición de mensaje individual
  const handleMensajeChange = (event) => {
    const nuevosMensajes = [...mensajesEditados];
    nuevosMensajes[mensajeEditando].mensaje = event.target.value;
    setMensajesEditados(nuevosMensajes);
  };

  // Manejar clic en "Editar"
  const handleEditarClick = (index) => {
    setMensajeEditando(index);
  };

  // Manejar clic en "Cancelar"
  const handleCancelarClick = () => {
    setMensajeEditando(null);
  };

  // control if especialista ID is inside of list interDestAllow
  const checkIfCurrentUserIsAllowed = (str, val) => {
    return str.split(",").includes(val+"");
  };

  const removeDuplicates = (array, prop) => {
    const uniqueValues = new Map();
    array.forEach(item => {
        uniqueValues.set(item[prop], item);
    });
    return Array.from(uniqueValues.values());
  };

  // 0.0 Set initial values. Avoid show the same data
  useEffect(() => {
      setInterResp(interconsulta.meta?.interResp);
      setInterRespId(interconsulta.author);
      setMetafecha(interconsulta.meta?.metaFecha);
      setInterAsu(interconsulta.meta?.interAsu);
      setInterDest(interconsulta.meta?.interDest);
      setInterDestAllow(interconsulta.meta?.interDestAllow);
      setInterObs(interconsulta.meta?.interObs);
      setInterHiloPrev(interconsulta.meta?.interHilo);
      setMensajesEditados(interconsulta.meta?.interHilo);
  }, [interconsulta]);
  
  // 0.1 Listado Inicial de especialistas que recibirán notificación (InterDest - Current User)
  useEffect(() => {
    // Si interDestAll no está vacío
    if (interconsulta.meta?.interDest.length > 0) {

      setInterDestCurrent(interconsulta.meta?.interDest);
      // Lista de valores a eliminar
      const valuesToRemove = [props.especialistaId];
  
      // Filtrar el arreglo para excluir los elementos con los valores dados
      const filteredInterDestOptions = interconsulta.meta?.interDest.filter(item => !valuesToRemove.includes(item.value));
  
      // Actualizar el estado con el nuevo arreglo filtrado
      setInterDestNot(filteredInterDestOptions);
    }
  }, [interconsulta]);

  // 0.5 Load Especialistas
  useEffect(() => {
    const loadEspecialistasAll = async () => {
      // Till the data is fetch using API
      // the Loading page will show.
      setLoading(true);

      // Await make wait until that
      // promise settles and return its result
      const response = await APIESPECIALISTAS.getAllEspecialistasInTreatAndPsicoHospAndAdmins(tratamientoId);

      // After fetching data stored it in posts state.
      setInterDestAll(response);

      // Closed the loading page
      setLoading(false);
    };

    // Call the function
    loadEspecialistasAll();
  }, [tratamientoId]);

  // 1. Clean Especialistas (remove Author and Current from Options)
  useEffect(() => {
    // Si interDestAll no está vacío
    if (interDestAll.length > 0) {
      // Lista de valores a eliminar
      const valuesToRemove = [props.especialistaId];
  
      // Filtrar el arreglo para excluir los elementos con los valores dados
      const filteredInterDestOptions = interDestAll.filter(item => !valuesToRemove.includes(item.value));
  
      // Actualizar el estado con el nuevo arreglo filtrado
      setInterDestOptions(filteredInterDestOptions);
    }
  }, [interDestAll]);

  // 3. Crear listado de grupo receptor del mensaje. Usuarios Current (modificaciones si Admin elimina) + Usuarios Notificacion
  useEffect(() => {
    // Unir los dos arrays y eliminar duplicados
    const combinedArray = removeDuplicates([...interDestCurrent, ...interDestNot], 'value');

    // Definir los IDs de los especialistas que llevarán notificación
    if (typeof interDestNot === "object" && interDestNot !== null && Object.keys(interDestNot).length > 0) {
      let allSelectedId = interDestNot.map((field) => field.value);
      setInterNoti(allSelectedId);
    } else {
      setInterNoti('');
    }

    // Actualizar el estado interDest con el nuevo array
    setInterDest(combinedArray);
  }, [interDestCurrent, interDestNot]);

  // 4.Create an array of Ids of selected Especialistas
  useEffect(() => {
    if (typeof interDest === "object" && interDest !== null && Object.keys(interDest).length > 0) {
      let allSelectedId = interDest.map((field) => field.value);
      let allowIds = allSelectedId.concat(props.especialistaId);
      setInterDestAllow(allowIds.toString());
    }
  }, [interDest]);

  const interHiloLast = [
    // { autor: 'Manuel Garrido', fecha: '2022-12-26', mensaje: 'Mensaje de prueba' },
    { autorId: interHiloAutorId, autor: interHiloAutor, fecha: interHiloFecha, mensaje: interHiloMensaje }
    // { autorId: interHiloAutorId, autor: interHiloAutor, fecha: interHiloFecha, destinatarios: interHiloDestinatarios, mensaje: interHiloMensaje }
  ]

  // const interHilo = [
  //   { autor: 'Manuel Garrido', fecha: '2022-12-26', mensaje: 'Mensaje de prueba' },
  //   //{ autor: interHiloAutor, fecha: interHiloFecha, mensaje: interHiloMensaje }
  // ]

  //interHilo.push(interHiloLast)

  // si interHilo tiene valor

  const toggleGrid = () => {
    setShowGrid(!showGrid); // Cambiar el estado para mostrar u ocultar el bloque
  };

  const toggleModal = () => {
    setShowModal(!showModal);
  };


  const submitInterconsulta = async (e) => {
    e.preventDefault();
    setIsCreatingButton(true);
    let interHiloUpdate = interHiloPrev.concat(interHiloLast);
    //interHilo.push(interHiloLast);
    console.log(
      interDest,
      interDestAllow,
      interHiloUpdate,
      interconsultaId
    );
    try {
      const val = await InterconsultaUpdate(
        interDest,
        interDestAllow,
        interHiloUpdate,
        interconsultaId
      );

      // Iterar sobre cada ID en interNoti y crear una notificación para cada uno
      let notiUrl = `pacientes/${pacienteId}/${tratamientoId}/interconsultas/${val.id}`;
      let cleanDate = FormatDate(todayDate);
      let notiText = `${cleanDate} - Nuevo mensaje en Interconsulta de Paciente: ${pacienteName}`;
      for (const id of interNoti) {
        await NotificacionCreate(
          id,
          metaFecha,
          notiText,
          notiUrl,
          false);
      }

      setInterHiloMensaje('');
      window.location.replace(`../interconsultas/${interconsultaId}`);
    } catch (error) {
      console.error(error);
    } finally {
      setIsCreatingButton(false);
      toggleGrid();
    }
    
  };

  const editInterconsultaMensaje = async (e) => {
    setIsCreatingButton(true);
    e.preventDefault();    //interHilo.push(interHiloLast);
    console.log(
      interDest,
      interDestAllow,
      mensajesEditados,
      interconsultaId
    );
    try {
      const val = await InterconsultaUpdate(
        interDest,
        interDestAllow,
        mensajesEditados,
        interconsultaId
      );

      setInterHiloMensaje('');
      setMensajeEditando(null);
      window.location.replace(`../interconsultas/${interconsultaId}`);
    } catch (error) {
      console.error(error);
    } finally {
      setIsCreatingButton(false);
    }
  };

  const deleteItem = async (e) => {
    e.preventDefault();
    setIsDeletingButton(true);
    try {
      await InterconsultaDelete(
        interconsultaId
      ).then(
        (val) => {
          window.location.replace(`../interconsultas/`);
        },
        (error) => {
          console.log(error);
        }
      );
    } catch (err) {
      console.log(err);
    } finally {
      setIsDeletingButton(false);
    }
  };
 // 
  return (
    <>
    <div id="content">
      {interconsulta.length === 0 ? (
        <div>Cargando...</div>
      ) : (
        ((!checkIfCurrentUserIsAllowed(interDestAllow, props.especialistaId) && (!props.userRole.includes('administrador'))) ? (
          <h1>No tiene permisos suficientes para visualizar esta sección</h1>
        ) : (
      <form id="formUpdatelement" onSubmit={submitInterconsulta}>
        <div className=''>
          <h1>Asunto: {interAsu}</h1>
          <div className='field'>
              <label htmlFor='interDest'>Participantes:</label>
              <div className='control'>
                <Select
                  isMulti
                  id='interDest'
                  name='interDest'
                  className={`basic-multi-select interconsulta-participantes ${props.userRole.includes('administrador') ? 'interconsulta-admin' : ''}`}
                  classNamePrefix='select'
                  isLoading={loading}
                  placeholder='Sin participantes'
                  value={interDestCurrent}
                  onChange={setInterDestCurrent}
                />
              </div>
          </div>

          <div className="inter-container">
            <p><span className="metaFecha">{FormatDate(metaFecha)}</span><span className="interSeparator"> | </span><span className="interAutor">{interResp}</span></p>
            <p style={{ whiteSpace: 'pre-line' }}>{interObs}</p>
          </div>
          {interHiloPrev.length === 0 ? (
            <div>Sin respuestas</div>
          ) : (
            <>


            {mensajesEditados.map((mensaje, index) => (
        <div key={index} className="inter-container">
          <p>
            <span className="metaFecha">{FormatDate(mensaje.fecha)}</span>
            <span className="interSeparator">|</span>
            <span className="interAutor">{mensaje.autor}</span>
          </p>
          {mensajeEditando === index ? (
            <div>
              <textarea
                value={mensaje.mensaje}
                onChange={handleMensajeChange}
                className="textarea"
              />
              <div className="tiny-actions ">
                <p className="button is-link is-light" onClick={handleCancelarClick}>Cancelar</p>
                <p className="button is-link" onClick={editInterconsultaMensaje}>Guardar</p>
              </div>
            </div>
          ) : (
            <div>
              <p style={{ whiteSpace: 'pre-line' }}>{mensaje.mensaje}</p>
              {props.userRole.includes('administrador') &&
                <a className="has-text-link" onClick={() => handleEditarClick(index)}>Editar</a>
              }
            </div>
          )}
        </div>
      ))}


            
            </>
          )}
        </div>
        <div className={showGrid ? '' : 'is-hidden'}>
          <div className='grid--2col'>
            <div className='field'>
              <label htmlFor='interHiloAutor'>Autor Respuesta</label>
              <div className='control'>
                <input
                  className='input'
                  id='interHiloAutor'
                  required
                  type='text'
                  disabled
                  value={interHiloAutor}
                  onChange={(e) => setInterHiloAutor(e.target.value)}
                />
              </div>
            </div>
            {/* <div className='field'>
              <label htmlFor='interHiloFecha'>Fecha Respuesta *completado automático</label>
              <div className='control'>
                <input
                  className='input'
                  id='interHiloFecha'
                  required
                  type='date'
                  value={interHiloFecha}
                  onChange={(e) => setInterHiloFecha(e.target.value)}
                />
              </div>
            </div> */}
            <div className='field'>
              <label htmlFor='interDest'>Notificar a los siguientes participantes</label>
              <div className='control'>
                <Select
                  isMulti
                  id='interDest'
                  name='interDest'
                  options={interDestOptions}
                  className='basic-multi-select'
                  classNamePrefix='select'
                  isLoading={loading}
                  placeholder='Seleccionar destinatarios para notificaciones'
                  value={interDestNot}
                  onChange={setInterDestNot}
                />
              </div>
            </div>
          </div>
          <div className='field'>
            <label htmlFor='interHiloMensaje'>Mensaje</label>
            <div className='control'>
              <textarea
                required
                disabled={!showGrid ? 'disabled' : ''}
                className='textarea'
                name='interHiloMensaje'
                id='interHiloMensaje'
                value={interHiloMensaje}
                onChange={(e) => setInterHiloMensaje(e.target.value)}
              ></textarea>
            </div>
          </div>
        </div>
      </form>
      )))}
    </div>
    
    <div id='actions'>
        {showGrid ? (
          <>
            <button className="button is-link" id="submitButton" type="submit" disabled={isCreatingButton} onClick={submitInterconsulta}>{isCreatingButton ? <div className="spinner"></div> : 'Enviar'}</button>
            <button className="button is-link is-light" id="cancelButton" onClick={toggleGrid}>Cancelar</button>
          </>
        ) : (
          <button className="button is-link" id="replyButton" onClick={toggleGrid}>Responder</button>
        )}
        {props.userRole.includes('administrador') &&
          <button className="button is-danger" id="deleteButton" disabled={isDeletingButton} onClick={toggleModal}>{isDeletingButton ? <div className="spinner"></div> : 'Eliminar'}</button>
        }
      </div>
      {/* Modal */}
      {showModal && (
        <div className="modal is-active">
          <div className="modal-background"></div>
          <div className="modal-card">
            <header className="modal-card-head">
              <p className="modal-card-title">Confirmar Eliminar</p>
              <button className="delete" aria-label="close" onClick={toggleModal}></button>
            </header>
            <section className="modal-card-body">
              <p>Esta acción eliminará todo el contenido</p>
            </section>
            <footer className="modal-card-foot">
              <button className="button is-danger" onClick={deleteItem}>Eliminar</button>
              <button className="button is-link is-light" onClick={toggleModal}>Cancelar</button>
            </footer>
          </div>
        </div>
        
      )}
    {/* <div id='actions'>
        <button className="button is-link" id="saveButton" form="formUpdatelement" type="submit">Responder</button>
        {(props.userRole.includes('administrador'))  &&
        <button className="button is-danger" id="deleteButton" onClick={deleteItem}>Eliminar</button>
        }
    </div> */}
    {/* <div className="modal">
          <div className="modal-content">
            <p>¿Estás seguro de que deseas eliminar este contenido?</p>
            <div className="modal-buttons">
              <button className="button is-danger" onClick={deleteItem}>Eliminar</button>
              <button className="button" onClick={toggleModal}>Cancelar</button>
            </div>
          </div>
        </div> */}
    </>
  );
}
